<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>波次分播</div>
      <el-button
        style="margin-left: 20px"
        type="primary"
        @click="
          initData();
          machineStatusTableVisible = true;
        "
        >查看设备状态</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <el-collapse-transition>
          <div>
            <div
              style="
                background: #f3f3f3;
                height: 50px;
                line-height: 30px;
                padding: 0 25px;
                display: flex;
                align-items: center;
              "
            >
              <el-select
                v-model="machine_id"
                placeholder="选择分播设备"
                style="width: 150px"
                @change="getCase"
              >
                <el-option
                  v-for="item in machines"
                  :key="item.machine_id"
                  :label="item.machine_no"
                  :value="item.machine_id"
                ></el-option>
              </el-select>
              <el-select
                v-model="machine_cut_type"
                placeholder="选择分播类型"
                style="margin: 0 20px"
                @change="getCase"
              >
                <el-option
                  v-for="(item, index) in machine_cut_types"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-select
                v-model="machine_cut_case_id"
                placeholder="选择分播方案"
                @change="handleCutCaseChange"
              >
                <el-option
                  v-for="item in machine_cut_cases"
                  :key="item.case_id"
                  :value="item.case_id.toString()"
                  :label="item.case_name"
                ></el-option>
              </el-select>
              <el-input
                v-if="
                  machine_cut_case && machine_cut_case.is_need_package === '1'
                "
                ref="refPackageInput"
                v-model="binding_package_no"
                placeholder="请输入包裹号"
                :disabled="inputDisabled"
                style="margin: 0 20px; width: 140px"
                @keyup.enter.native="setType"
                @change="determineNotQZ"
              ></el-input>

              <el-button
                type="primary"
                style="margin-left: 20px"
                @click="handleSwitchPackage"
                >切换包裹</el-button
              >

              <el-button
                type="success"
                style="margin-left: 20px"
                @click="setType"
                >开始分播</el-button
              >

              <el-button
                type="danger"
                :disabled="resData.machine_status != 1"
                @click="stopCut()"
                >结束分播</el-button
              >

              <el-button
                style="margin-left: auto"
                type="primary"
                size="mini"
                @click="fetchData"
                >刷新页面</el-button
              >
              <span>最后刷新时间:{{ resData.time }}</span>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 波次分播的表格 -->
    <!--一分八-->
    <div v-if="set_machine.cut_type == -1">
      <div v-show="is_1v8 == 1">
        <div v-for="(item, index) in resData.cut_data" :key="index">
          <div
            style="
              width: 20%;
              float: left;
              height: 10%;
              margin: 0 auto;
              margin-left: 1%;
              margin-top: 10px;
              border: 1px solid #3a8ee6;
              text-align: center;
            "
          >
            <p class="box_p">
              <span style="float: left; margin-left: 15px">{{
                item.picking_assignment_no
              }}</span>
            </p>
            <br />
            <p class="box_p">
              <span style="float: left; margin-left: 15px"
                >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                  item.wave_picking_num
                }}</span
              >
            </p>
            <br />
            <p class="box_p">
              <span style="float: left; margin-left: 15px"
                >异常数量:{{ item.yc_num }}</span
              >
            </p>
            <br />
            <p class="box_p">
              <span style="float: left; margin-left: 15px"
                >波次数量:{{ item.wp_num }}</span
              >
            </p>
            <br />
            <p>
              <el-button
                style="float: left; margin-left: 15px; margin-bottom: 15px"
                type="success"
                size="mini"
                @click="showGrid(-1, item.picking_assignment_no)"
                >查看格口
              </el-button>
            </p>
          </div>
        </div>
      </div>
      <!--非一分八-->

      <div v-show="is_1v8 == 0">
        <div style="margin-bottom: 0; width: 100%">
          <el-button v-if="resData.cut_data" type="primary" plain
            >拣货任务分播</el-button
          >
          <div v-for="item in resData.cut_data">
            <div
              style="
                width: 20%;
                float: left;
                height: 10%;
                margin: 0 auto;
                margin-left: 1%;
                margin-top: 10px;
                border: 1px solid #3a8ee6;
                text-align: center;
              "
            >
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >拣货单号:{{ item.cut_no }}</span
                >
              </p>
              <br />
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >拣货方式:{{ item.assignment_type_text }} 波次类型:常规</span
                >
              </p>
              <br />
              <br />
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                    item.wave_picking_num
                  }}</span
                ><span style="float: right; margin-right: 15px"
                  >{{ item.cut_time }}/s</span
                >
              </p>
              <br />
              <p>
                <el-button
                  style="float: left; margin-left: 15px; margin-bottom: 15px"
                  type="success"
                  size="mini"
                  @click="showGrid(-1, item.cut_no, 1)"
                  >查看格口
                </el-button>
                <el-button
                  style="float: right; margin-right: 15px"
                  type="danger"
                  size="mini"
                  @click="stopCut(item.cut_no, 1)"
                  >结束分播
                </el-button>
              </p>
            </div>
          </div>
        </div>
        <div
          style="margin-bottom: 0; width: 100%; float: left; margin-top: 20px"
        >
          <el-button v-if="resData.cut_data2" type="primary" plain
            >汇总分播</el-button
          >
          <div v-for="item in resData.cut_data2">
            <div
              style="
                width: 20%;
                float: left;
                height: 10%;
                margin: 0 auto;
                margin-left: 1%;
                margin-top: 10px;
                border: 1px solid #3a8ee6;
                text-align: center;
              "
            >
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >汇总号:{{ item.cut_no }}</span
                >
              </p>
              <br />
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >拣货方式:{{ item.type_text }}汇总 波次类型:{{
                    item.type_text
                  }}</span
                >
              </p>
              <br />
              <br />
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                    item.wave_picking_num
                  }}</span
                ><span style="float: right; margin-right: 15px"
                  >{{ item.cut_time }}/s</span
                >
              </p>
              <br />
              <p>
                <el-button
                  style="float: left; margin-left: 15px; margin-bottom: 15px"
                  type="success"
                  size="mini"
                  @click="showGrid(-1, item.cut_no, 2)"
                  >查看格口
                </el-button>
                <el-button
                  style="float: right; margin-right: 15px"
                  type="danger"
                  size="mini"
                  @click="stopCut(item.cut_no, 2)"
                  >结束分播
                </el-button>
              </p>
            </div>
          </div>
        </div>
        <div
          style="margin-bottom: 0; width: 100%; float: left; margin-top: 20px"
        >
          <el-button v-if="resData.cut_data3" type="primary" plain
            >中分任务分播</el-button
          >
          <div v-for="item in resData.cut_data3">
            <div
              style="
                width: 20%;
                float: left;
                height: 10%;
                margin: 0 auto;
                margin-left: 1%;
                margin-top: 10px;
                border: 1px solid #3a8ee6;
                text-align: center;
              "
            >
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >中分任务:{{ item.cut_no }}</span
                >
              </p>
              <br />
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >拣货方式:{{ item.picking_type }} 波次类型:{{
                    item.wave_type
                  }}</span
                >
              </p>
              <br />
              <br />
              <p class="box_p">
                <span style="float: left; margin-left: 15px"
                  >已播/已拣/所需:{{ item.cut_num }}/{{ item.sm_num }}/{{
                    item.wave_picking_num
                  }}</span
                ><span style="float: right; margin-right: 15px"
                  >{{ item.cut_time }}/s</span
                >
              </p>
              <br />
              <p>
                <el-button
                  style="float: left; margin-left: 15px; margin-bottom: 15px"
                  type="success"
                  size="mini"
                  @click="showGrid(-1, item.cut_no, 3)"
                  >查看格口
                </el-button>
                <el-button
                  style="float: right; margin-right: 15px"
                  type="danger"
                  size="mini"
                  @click="stopCut(item.cut_no, 3)"
                  >结束分播
                </el-button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 入库分播 -->
    <div v-else>
      <!-- 虽然这里只会有一个框, 但是为了结构完整, 还是这样吧 -->
      <div
        v-for="(item, index) in resData.cut_data"
        :key="index"
        style="
          width: 20%;
          float: left;
          height: 10%;
          margin: 0 auto;
          margin-left: 1%;
          margin-top: 10px;
          border: 1px solid #3a8ee6;
          text-align: center;
        "
      >
        <p class="box_p">
          <span style="float: left; margin-left: 15px">{{
            {
              1: "入库分播",
              2: "按次品员",
              3: "按中分位",
              5: "按中分位分组",
              "-2": "波次粗分",
            }[set_machine.cut_type]
          }}</span>
        </p>
        <br />
        <p class="box_p">
          <span style="float: left; margin-left: 15px"
            >已播:{{ item.cut_num }}</span
          >
        </p>
        <br />
        <p class="box_p">
          <span style="float: left; margin-left: 15px"
            >异常数量:{{ item.yc_num }}</span
          >
        </p>
        <br />
        <br />
        <p>
          <el-button
            style="float: left; margin-left: 15px; margin-bottom: 15px"
            type="success"
            size="mini"
            @click="showGrid(set_machine.cut_type, '')"
            >查看格口</el-button
          >
        </p>
      </div>
    </div>
    <br />
    <el-row
      v-if="is_1v8 == 1 && resData.grid_data.length > 0"
      style="width: 100%; float: left"
    >
      <el-col :span="1">
        <el-row class="line_y">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="1">
        <el-row class="line_left">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="1">
        <el-row class="line_right">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="1">
        <el-row class="line left-top">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="1">
        <el-row class="line left-bottom">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="1">
        <el-row class="line right-top">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="1">
        <el-row class="line right-bottom">
          <hr style="border: 0" />
        </el-row>
      </el-col>
      <el-col :span="6" style="margin: 20px">
        <el-row :gutter="40">
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[0])">
              <div :class="resData.grid_data[0].grid_style">
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[0].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[0].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[0].grid_no)"
                    >关闭容器</el-button
                  >
                </p>

                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[0].grid_no)"
                    >提取格口</el-button
                  >
                </p>

                <p>{{ resData.grid_data[0].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[0].grid_type }}
                </p>
                <p v-show="resData.grid_data[0].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[0].is_sc_grid == 2" class="pad">
                  微次
                </p>
                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:
                  {{ resData.grid_data[0].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[0].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[1])">
              <div :class="resData.grid_data[1].grid_style">
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[1].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[1].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[1].grid_no)"
                    >关闭容器</el-button
                  >
                </p>

                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[1].grid_no)"
                    >提取格口</el-button
                  >
                </p>

                <p>{{ resData.grid_data[1].grid_no }}</p>

                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[1].grid_type }}
                </p>
                <p v-show="resData.grid_data[1].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[1].is_sc_grid == 2" class="pad">
                  微次
                </p>
                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[1].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[1].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[2])">
              <div :class="resData.grid_data[2].grid_style">
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[2].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[2].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[2].grid_no)"
                    >关闭容器</el-button
                  >
                </p>
                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[2].grid_no)"
                    >提取格口</el-button
                  >
                </p>
                <p>{{ resData.grid_data[2].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[2].grid_type }}
                </p>
                <p v-show="resData.grid_data[2].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[2].is_sc_grid == 2" class="pad">
                  微次
                </p>

                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[2].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[2].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[3])">
              <div :class="resData.grid_data[3].grid_style">
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[3].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[3].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[3].grid_no)"
                    >关闭容器</el-button
                  >
                </p>
                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[3].grid_no)"
                    >提取格口</el-button
                  >
                </p>
                <p>{{ resData.grid_data[3].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[3].grid_type }}
                </p>
                <p v-show="resData.grid_data[3].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[3].is_sc_grid == 2" class="pad">
                  微次
                </p>
                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[3].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[3].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col
        :span="2"
        style="
          font-size: 50px;
          margin-top: 20px;
          text-align: center;
          color: black;
        "
      >
        <el-row>
          <i class="el-icon-monitor" />
        </el-row>
      </el-col>
      <el-col :span="6" style="margin: 20px">
        <el-row :gutter="40">
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[4])">
              <div :class="resData.grid_data[4].grid_style">
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[4].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[4].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[4].grid_no)"
                    >关闭容器</el-button
                  >
                </p>
                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[4].grid_no)"
                    >提取格口</el-button
                  >
                </p>
                <p>{{ resData.grid_data[4].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[4].grid_type }}
                </p>
                <p v-show="resData.grid_data[4].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[4].is_sc_grid == 2" class="pad">
                  微次
                </p>
                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[4].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[4].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[5])">
              <div :class="resData.grid_data[5].grid_style">
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[5].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[5].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[5].grid_no)"
                    >关闭容器</el-button
                  >
                </p>
                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[5].grid_no)"
                    >提取格口</el-button
                  >
                </p>
                <p>{{ resData.grid_data[5].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[5].grid_type }}
                </p>
                <p v-show="resData.grid_data[5].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[5].is_sc_grid == 2" class="pad">
                  微次
                </p>

                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[5].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[5].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="40">
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[6])">
              <div :class="resData.grid_data[6].grid_style">
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[6].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[6].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[6].grid_no)"
                    >关闭容器</el-button
                  >
                </p>
                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[6].grid_no)"
                    >提取格口</el-button
                  >
                </p>
                <p>{{ resData.grid_data[6].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[6].grid_type }}
                </p>
                <p v-show="resData.grid_data[6].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[6].is_sc_grid == 2" class="pad">
                  微次
                </p>

                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[6].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[6].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div v-if="checkGrid(resData.grid_data[7])">
              <div
                v-if="checkGrid(resData.grid_data[7])"
                :class="resData.grid_data[7].grid_style"
              >
                <p v-if="showOnIn()" class="pad">
                  {{ resData.grid_data[7].box_no }}
                </p>
                <p v-if="showOnIn()" class="pad">
                  <el-button
                    v-if="resData.grid_data[7].box_no"
                    size="mini"
                    type="primary"
                    @click="closeBox(resData.grid_data[7].grid_no)"
                    >关闭容器</el-button
                  >
                </p>
                <p v-if="showOnWaveRoughCut()" class="pad">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="pickGrid(resData.grid_data[7].grid_no)"
                    >提取格口</el-button
                  >
                </p>
                <p>{{ resData.grid_data[7].grid_no }}</p>
                <p v-if="showOnIn() || showMedianGroupName()" class="pad">
                  {{ resData.grid_data[7].grid_type }}
                </p>
                <p v-show="resData.grid_data[7].is_sc_grid == 1" class="pad">
                  {{ machine_cut_type == 4 ? "不出库" : "色差" }}
                </p>
                <p v-show="resData.grid_data[7].is_sc_grid == 2" class="pad">
                  微次
                </p>

                <p class="box_p">
                  已播<span v-if="showOnWave()">/所需</span>:{{
                    resData.grid_data[7].cut_num
                  }}<span v-if="showOnWave()"
                    >/{{ resData.grid_data[7].wave_picking_num }}</span
                  >
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog title="详情" :visible.sync="girdVisible">
      <el-table v-if="showOnWave()" :data="infoDetail">
        <el-table-column
          property="wave_picking_no"
          label="波次号"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          property="grid_no"
          label="格口"
          align="center"
          width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="cut_dbids" label="打标ID"> </el-table-column>
      </el-table>

      <el-table v-else :data="infoDetail">
        <el-table-column
          property="grid_no"
          label="格口号"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          property="grid_type"
          :label="
            { 1: '格口类型', 2: '次品员', 3: '中分位', 5: '按中分位分组' }[
              set_machine.cut_type
            ]
          "
          align="center"
          width="220"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column prop="dbids" label="打标ID"></el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="设备使用状态" :visible.sync="machineStatusTableVisible">
      <el-table :data="machines">
        <el-table-column
          property="machine_no"
          label="设备编号"
          width="150"
        ></el-table-column>
        <el-table-column
          property="machine_status"
          :formatter="formatterMachineStatus"
          label="使用状态"
          width="200"
        ></el-table-column>
        <el-table-column
          property="use_admin_name"
          :formatter="formatterUseAdminName"
          label="操作人"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
// 按中分位分组
const MEDIAN_DISTRIBUTION_GROUP = 5;
export default {
  beforeRouteLeave(to, from, next) {
    clearInterval(this.timer);
    next();
  },
  data() {
    return {
      inputDisabled: false,
      binding_package_no: "",
      init_machine_id: "",
      machine_id: "",
      is_1v8: 1,
      machines: [],
      resData: {
        grid_data: [],
        cut_dtata: [],
        time: "",
      },
      form: {
        summary_no: "",
        box_no: "",
        dbid: "",
      },
      loading: false,
      status: "",
      curPage: 1,
      filterFold: false,
      wave_picking: [],
      cur_wave: "",
      voice: "",
      timer: null,
      girdVisible: false,
      infoDetail: [],
      machine_cut_types: {}, // 分播类型下拉
      machine_cut_cases: [], // 分播方案下拉
      machine_cut_type: "", // 分播类型
      machine_cut_case: { case_id: "", case_name: "", is_need_package: "0" }, // 分播方案
      machine_cut_case_id: "",

      // 绑定分播方案之后的数据
      set_machine: {
        cut_type: 0, // 分播类型
        grid_bind_box: {}, // 需要绑定容器的格口
      },

      need_get_cut_data: true, // 这个用来判断是否需要获取数据, 不然弹窗绑定格口有问题
      machineStatusTableVisible: false, // 显示设备状态的表格
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.need_get_cut_data) this.fetchData();
    }, 5000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    handleCutCaseChange(value) {
      console.log(
        "🚀 ~ file: machineCut.vue ~ line 955 ~ handleCutCaseChange ~ value",
        value
      );
      this.machine_cut_case =
        this.machine_cut_cases.find((c) => c.case_id === value) || {};
    },
    determineNotQZ(value) {
      if (value.toLowerCase().indexOf("qz") > -1) {
        this.$message({
          message: "前置仓包裹商品暂不支持入库分播！",
          type: "error",
        });
        return false;
      }
      return true;
    },
    handleSwitchPackage() {
      if (!this.determineNotQZ(this.binding_package_no)) return;
      this.$confirm("切换包裹会提交批次，是否确定操作？", "切换包裹", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.switchPackage();
      });
      // .catch((err) => {
      //   this.$message({
      //     type: "info",
      //     message: "已取消删除",
      //   });
      // });
    },
    switchPackage() {
      const params = { binding_package_no: this.binding_package_no };
      this.$api
        .switchPackage(params)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message({ message: res.data.msg, type: "error" });
          } else {
            this.$message({ message: "操作成功", type: "success" });
            this.binding_package_no = "";
            this.inputDisabled = false;
            this.$refs.refPackageInput.focus();
          }
        })
        .catch((err) => {
          this.$message({ message: err, type: "error" });
        });
    },
    // 获取
    getCase() {
      this.machine_cut_case = {};
      if (!this.machine_cut_type || !this.machine_id) {
        return;
      }
      this.$http
        .post("/erp/Machine/getMachineCutCase", {
          machine_id: this.machine_id,
          machine_cut_type: this.machine_cut_type,
        })
        .then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.e(ra.data.msg);
          }
          this.machine_cut_cases = rs.data.data.list;
          this.binding_package_no = rs.data.data.binding_package_no;
          if (this.binding_package_no) {
            this.inputDisabled = true;
          }
          if (rs.data.data.list.length == 1) {
            this.machine_cut_case = rs.data.data.list[0];
            this.machine_cut_case_id = rs.data.data.list[0].case_id;
          }
        });
    },

    // 开始分播
    setType(val) {
      if (!this.determineNotQZ(this.binding_package_no)) return;
      const NEED_PACKAGE = "1";
      if (
        !this.binding_package_no &&
        this.machine_cut_case.is_need_package === NEED_PACKAGE
      ) {
        this.$message({ message: "请录入包裹号！", type: "error" });
        return;
      }
      const post = {
        machine_id: this.machine_id,
        machine_cut_type: this.machine_cut_type,
        machine_cut_case: this.machine_cut_case.case_id,
        binding_package_no: this.binding_package_no,
      };
      this.$http.post("/erp/Machine/setMachine", post).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.init_machine_id = this.machine_id;
          this.set_machine.cut_type = res.data.data.cut_type;
          this.fetchData();
          this.$message.success(res.data.msg);
          this.inputDisabled = true;
        }
      });
    },

    // 需要绑定容器号
    gridBingBox(grid_nos) {
      if (grid_nos.length == 0) {
        this.need_get_cut_data = true; // 没有格口需要绑定的时候就可以获取分播数据了
        return;
      }
      this.need_get_cut_data = false;
      grid_nos.forEach((v) => {
        this.set_machine.grid_bind_box[v] = "";
      });
      const len = grid_nos.length;
      let i = 1;
      const pop = function () {
        for (const k in this.set_machine.grid_bind_box) {
          if (this.set_machine.grid_bind_box[k].length == 0) {
            // 没有容器号就需要绑定
            // 弹窗
            this.$prompt(
              `<p>格口：${k} </p><p>进度：${i}/${len}</p>`,
              "绑定容器号",
              {
                showClose: false,
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                inputPlaceholder: "容器号",
                dangerouslyUseHTMLString: true,
              }
            ).then((val) => {
              this.tobindBox(val.value, k)
                .then((_) => {
                  if (i == len) {
                    this.fetchData();
                    this.need_get_cut_data = true; // 没有格口需要绑定的时候就可以获取分播数据了
                  }
                  i++;
                })
                .catch((_) => {})
                .finally((_) => {
                  console.log("i:", i);
                  pop();
                });
            });
            return; // 只弹窗一次
          }
        }
      }.bind(this);
      pop();
    },

    // 关闭容器
    closeBox(grid_no) {
      this.$http.post("/erp/Machine/closeBoxOnGrid", { grid_no }).then((rs) => {
        if (rs.data.code != 200) {
          return this.$message.e(rs.data.msg);
        }
        this.gridBingBox(rs.data.data);
        return this.$message.success(rs.data.msg);
      });
    },

    // 请求绑定容器号
    tobindBox(box_no, grid_no) {
      // let machine_id = this.init_machine_id;
      return new Promise((resolve, reject) => {
        this.$http
          .post("/erp/Machine/bindBoxOnGrid", { box_no, grid_no })
          .then((rs) => {
            if (rs.data.code != 200) {
              reject();
              return this.$message.e(rs.data.msg);
            }
            this.set_machine.grid_bind_box[grid_no] = box_no;
            resolve();
            return this.$message.success(rs.data.msg);
          });
      });
    },

    showGrid(type, picking_assignment_no, summary_type = 1) {
      this.$http
        .post("/erp/Machine/showGrid", {
          type,
          picking_assignment_no,
          summary_type,
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.girdVisible = true;
            this.infoDetail = res.data.data.data;
          }
        });
    },
    // 获取设备分播的设置
    initData() {
      this.$http
        .post("/erp/Machine/getInitData", this.filteredForm)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
          } else {
            this.init_machine_id = res.data.data.machine_id;
            this.machines = res.data.data.machines;
            this.machine_id = this.init_machine_id;
            this.machine_cut_types = res.data.data.machine_cut_types;
            this.machine_cut_type = res.data.data.machine_cut_type;
            this.machine_cut_case_id = res.data.data.machine_cut_case;
            if (this.machine_cut_case_id) {
              // 如果已经选中了, 就拿到分播方案
              this.getCase();
            }
            // 没有绑定容器的格口
            this.set_machine.cut_type = res.data.data.machine_cut_type;
            this.fetchData();
          }
        });
    },
    fetchData() {
      this.$http
        .post("/erp/Machine/getCutData", this.filteredForm)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message({ type: res.data.msg, type: "error" });
          } else {
            this.resData = res.data.data;
            console.log(this.resData, "this.resData");
            this.gridBingBox(res.data.data.need_bind_box_gird);
            if (typeof res.data.data.is_1v8 !== "undefined") {
              this.is_1v8 = res.data.data.is_1v8;
            }
          }
        });
    },
    stopCut(summary_no = "", type = 0) {
      let msg = "确认结束分播?";
      if (summary_no == "") {
        msg = "确认结束分播?此操作是整个设备结束,请注意!!";
      }
      this.$confirm(msg, "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/Machine/stopCut", {
              summary_no,
              type,
            })
            .then((res) => {
              setTimeout(() => {
                this.loading = false;
              }, 200);
              if (res.data.code !== 200) {
                this.$message.e(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.inputDisabled = false;
                this.fetchData();
              }
            });
        })
        .catch(() => {});
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    checkGrid(grid) {
      return !(typeof grid === "undefined");
    },
    // 入库类型才显示的东西
    showOnIn() {
      return this.set_machine.cut_type == 1;
    },
    // 按中分位分组显示分组名
    showMedianGroupName() {
      return Number(this.set_machine.cut_type) === MEDIAN_DISTRIBUTION_GROUP;
    },
    // 波次类型才显示的东西
    showOnWave() {
      return this.set_machine.cut_type == -1 || this.set_machine.cut_type == -2;
    },

    // 波次粗分才显示的东西
    showOnWaveRoughCut() {
      return this.set_machine.cut_type == -2;
    },

    // 提取格口
    pickGrid(grid_no) {
      // console.log('提取格口', grid_no);
      this.$http.post("/erp/Machine/extractGrid", { grid_no }).then((rs) => {
        if (rs.data.code != 200) {
          return this.$message.e(rs.data.msg);
        }
        this.$message.success(rs.data.msg);
        this.fetchData();
      });
    },

    // Format machine_status
    formatterMachineStatus(row, column) {
      // 0:无,1:分播中,2:结束分播
      if (row.machine_status == 1) {
        return "使用中";
      }
      return "未使用";
    },

    // Format use_admin_name
    formatterUseAdminName(row, column) {
      // 0:无,1:分播中,2:结束分播
      if (row.machine_status == 1) {
        return row.use_admin_name;
      }

      return "";
    },
  },
};
</script>

<style scoped>
.grid_g {
  width: 100%;
  float: left;
  border: 1px solid #3a8ee6;
  text-align: center;
  background-color: green;
  color: white;
}

.grid_r {
  width: 100%;
  float: left;
  border: 1px solid #3a8ee6;
  text-align: center;
  background-color: red;
  color: white;
}

.grid {
  width: 100%;
  float: left;
  border: 1px solid #3a8ee6;
  text-align: center;
  color: black;
}

.line_y {
  position: absolute;
  background-color: #666;
  height: 15px;
  top: 47%;
  left: 13.8%;
  width: 35.5%;
}

.line_left {
  position: absolute;
  background-color: #666;
  width: 15px;
  height: 60%;
  left: 13.3%;
  top: 22%;
}

.line_right {
  position: absolute;
  background-color: #666;
  width: 15px;
  height: 60%;
  left: 49%;
  top: 22%;
}

.line {
  position: absolute;
  background-color: #666;
  height: 15px;
  width: 2.3%;
}

.left-top {
  left: 12.6%;
  top: 17%;
}

.left-bottom {
  left: 12.6%;
  top: 81%;
}

.right-top {
  left: 48.3%;
  top: 17%;
}

.right-bottom {
  left: 48.3%;
  top: 81%;
}

.box_p {
  margin-top: 10px;
  margin-bottom: 10px;
}

.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 40px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.pad {
  height: 21px;
}
</style>



// WEBPACK FOOTER //
// src/pages/machine/machineCut.vue